import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import html2canvas from "html2canvas";

import {
  adjustBackgroundHeight,
  adjustBorderHeight,
  getQrCodeInfo,
  noInternetResponse,
  showToastMessage
} from "../../common/common";
import { getModelProfileData } from "../../data-services/edit-profile";
import { Network } from "@capacitor/network";
import axios from "axios";



const QR17ChobaniSuccess: React.FC = () => {
  const history = useHistory();
  const photoContainerRef = useRef<HTMLDivElement>(null);

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(730);
      adjustBackgroundHeight(870);
  }, []);

  const trackCTAClick = async () => {
    const options: any = {
      method: "post",
      url: `${process.env.REACT_APP_HP_API_URL}/users/registerConsumerCTA`,
      data: {
        uuid: localStorage.getItem('uuid'),
        ctaType: "cta1",
        ctaLabel: 'Chobani CTA button pressed'
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    await axios(options);
    // TODO: Update this URL to the correct RaceTrack destination
    window.location.href = 'https://www.instagram.com/chobani/'
  }

  return (
    <IonPage style={{background: 'white', alignItems: 'center'}}>

      <IonContent className={`lay__container--${qrDetails?.eventQrId}`} style={{maxWidth: '420px', margin: '0 auto'}}>
        <div className="lay__background">
          <img src="https://pulseqr.b-cdn.net/qr17Chobani/Background--no-logo.png" alt="Background" />
          <div style={{position: 'absolute', bottom: 0, maxWidth: '250px', zIndex: 3, lineHeight: 0, margin: '20px'}}>
            <img src="https://pulseqr.b-cdn.net/qr17Chobani/p3-bottom.png" style={{width: '100%', display: 'block'}} alt="Chobani products" />
          </div>
        </div>

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`} style={{overflow: 'hidden', height: '850px', margin: '30px 15px'}}>
            <img className="lay__berry" src="https://pulseqr.b-cdn.net/qr17Chobani/p3-b3.png" alt="" style={{top: '250px', left: '-15px'}} />
            <img className="lay__berry" src="https://pulseqr.b-cdn.net/qr17Chobani/p3-b1.png" alt="" style={{top: '350px', right: '-15px'}} />
            <img className="lay__berry" src="https://pulseqr.b-cdn.net/qr17Chobani/p3-b2.png" alt="" style={{bottom: '120px', left: '-15px'}} />
            <img className="lay__berry" src="https://pulseqr.b-cdn.net/qr17Chobani/p3-b4.png" alt="" style={{bottom: '50px', right: '-15px'}} />

            <div className="lay__logo">
              <div className="">
                <img style={{paddingTop: '0', marginTop: '0'}} src="https://pulseqr.b-cdn.net/qr17Chobani/logo.png" alt="Chobani" />
              </div>
            </div>

            <div className="img__first" onClick={trackCTAClick} style={{cursor: 'pointer',marginTop: '100px', marginBottom: '20px', zIndex: 10}}>
              <div className="">
                <img src="https://pulseqr.b-cdn.net/qr17Chobani/p3-img1.png" alt="You are in!" />
              </div>
            </div>

          </div>}
          
      </IonContent>

    </IonPage>
  );
};

export default QR17ChobaniSuccess;
